import { Box, Grid, styled, Typography } from '@mui/material';

export const VisualItemListContainer = styled(Box)`
  display: flex;
  width: 370px;
  padding: 20px 0;
  align-items: center;
  gap: 10px;
  & .MuiButton-root {
    min-width: unset;
    padding: unset;
  }
`;

export const VisualPath = styled(Typography)`
  width: 160px;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
`;

export const InputWidgetContainer = styled(Box)`
  width: 75px;
`;

export const GridContainer = styled(Grid)`
  margin-bottom: 20px;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 20px;
`;

export const GridVisualPath = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
